import { render, staticRenderFns } from "./BidNotifySettings.vue?vue&type=template&id=3dcabb7a&scoped=true"
import script from "./BidNotifySettings.vue?vue&type=script&lang=js"
export * from "./BidNotifySettings.vue?vue&type=script&lang=js"
import style0 from "./BidNotifySettings.vue?vue&type=style&index=0&id=3dcabb7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcabb7a",
  null
  
)

export default component.exports